class ProductBuyButtons extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button_container = this.querySelector(".product-buy-buttons--primary");
    this.button_text = this.querySelector(".product-buy-buttons--cta-text");
    this.form = this.querySelector(".product-buy-buttons--form");
    this.root = this.closest(`[data-product-id='${this.dataset.id}']`);
    this.select_input = this.querySelector(".product-buy-buttons--select");
    this.smart_button = this.querySelector(".product-buy-buttons--smart");
    this.primary_button = this.querySelector(".product-buy-buttons--cta");

    this.addToCartListener();
    this.updateViewListener();
  }

  addToCartListener() {
    if (!this.form) return;

    this.form.on("submit", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const form = e.target;
      const canAdd = theme.utils.getAvailableQuantity(form);
      if (!canAdd) return;

      if (this.button_container) {
        this.button_container.setAttribute("data-loading", true);
      }

      try {
        const ok = await theme.cart.addItem(form);

        if (this.button_container) {
          this.button_container.setAttribute("data-loading", false);
        }

        if (!ok) return;

        await theme.cart.updateAllHtml();
        this.addProductComplete();
      } catch (err) {
        if (this.button_container) {
          this.button_container.setAttribute("data-loading", false);
        }
        console.error(err);
      }
    });
  }

  addProductComplete() {
    theme.off_canvas.toggleView("cart");
    if (theme.off_canvas.state === "closed") {
      theme.off_canvas.openRight();
      theme.off_canvas.last_trigger = this.primary_button;
    }
  }

  updateViewListener() {
    window.on("theme:product:variantChanged", ({ detail: { section, variant } }) => {
      if (section !== this.root) return;

      const prev = this.select_input?.querySelector("option[selected]");
      if (prev) prev.removeAttribute("selected");

      if (variant && variant.available) {
        this.selectVariant(variant.id);
        this.updateView(true, true);
      } else if (variant && !variant.available) {
        this.selectVariant(variant.id);
        this.updateView(false, true);
      } else {
        this.updateView(false, false);
      }
    });
  }

  selectVariant(id) {
    const opt = this.select_input?.querySelector(`option[value='${id}']`);
    if (opt) opt.setAttribute("selected", true);
  }

  updateView(isAvailable, hasVariant) {
    if (isAvailable) {
      this.primary_button?.removeAttribute("disabled");
      if (this.button_text) this.button_text.innerText = theme.translations.add_to_cart;
      if (this.smart_button) this.smart_button.style.display = "block";
    } else {
      this.primary_button?.setAttribute("disabled", true);
      if (this.smart_button) this.smart_button.style.display = "none";
      if (this.button_text) {
        this.button_text.innerText = hasVariant
          ? theme.translations.out_of_stock
          : theme.translations.unavailable;
      }
    }
  }
}

const productBuyButtonsEl = customElements.get("product-buy-buttons-root");
if (!productBuyButtonsEl) {
  customElements.define("product-buy-buttons-root", ProductBuyButtons);
}